/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_pomodoro_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long is a Pomodoro?`)
};

const es_timer_pomodoro_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuánto dura un Pomodoro?`)
};

const de_timer_pomodoro_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie lang ist ein Pomodoro?`)
};

const nl_timer_pomodoro_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe lang duurt een Pomodoro?`)
};

const fr_timer_pomodoro_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de temps dure un Pomodoro ?`)
};

const it_timer_pomodoro_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto dura un Pomodoro?`)
};

const pt_br2_timer_pomodoro_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo dura um Pomodoro?`)
};

const pt_timer_pomodoro_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo dura um Pomodoro?`)
};

const ja_timer_pomodoro_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ポモドーロの長さはどのくらいですか？`)
};

const zh_timer_pomodoro_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一个番茄钟时长是多久？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_pomodoro_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_pomodoro_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_pomodoro_faq1_q", locale)
	if (locale === "en") return en_timer_pomodoro_faq1_q(inputs)
	if (locale === "es") return es_timer_pomodoro_faq1_q(inputs)
	if (locale === "de") return de_timer_pomodoro_faq1_q(inputs)
	if (locale === "nl") return nl_timer_pomodoro_faq1_q(inputs)
	if (locale === "fr") return fr_timer_pomodoro_faq1_q(inputs)
	if (locale === "it") return it_timer_pomodoro_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_pomodoro_faq1_q(inputs)
	if (locale === "pt") return pt_timer_pomodoro_faq1_q(inputs)
	if (locale === "ja") return ja_timer_pomodoro_faq1_q(inputs)
	return zh_timer_pomodoro_faq1_q(inputs)
};